export default __webpack_public_path__ + "static/media/pay.931505e7.png";